class MoviePoster {
  constructor() {
    this.product = JSON.parse(document.getElementById('MoviePosterJson').textContent);

    this.priceEl = document.getElementById('mpPrice');
    this.sizesEl = document.getElementById('mpSizes');
    this.sizeSelected = document.getElementById('mpSizeSelected');
    this.variantIdInput = document.getElementById('mpVariantId');
    this.form = document.querySelector('[data-movie-poster] .cinema__form');
    this.addBtn = document.getElementById('mpAddBtn');
    this.personalizationInput = document.getElementById('mpPersonalization');

    this._sizeChosen = false;

    this.initSizes();
    this.initInputs();
    this.initForm();
    this.validate();
  }

  initSizes() {
    const buttons = this.sizesEl.querySelectorAll('.cinema__size-btn');

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        this._sizeChosen = true;
        this.selectSize(btn);
        this.validate();
      });
    });
  }

  selectSize(btn) {
    const size = btn.getAttribute('data-size');
    const variantId = btn.getAttribute('data-variant-id');
    const price = btn.getAttribute('data-price');

    if (this.sizeSelected) {
      this.sizeSelected.textContent = size;
    }

    const formatted = (parseInt(price) / 100).toFixed(2);
    this.priceEl.textContent = '$' + formatted;

    if (this.variantIdInput) {
      this.variantIdInput.value = variantId;
    }
  }

  initInputs() {
    if (this.personalizationInput) {
      this.personalizationInput.addEventListener('input', () => this.validate());
    }
  }

  validate() {
    const persOk = this.personalizationInput && this.personalizationInput.value.trim().length > 0;

    if (this._sizeChosen && persOk) {
      this.addBtn.disabled = false;
      this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    } else {
      this.addBtn.disabled = true;
      if (!this._sizeChosen) {
        this.addBtn.innerHTML = 'SELECT A SIZE';
      } else if (!persOk) {
        this.addBtn.innerHTML = 'ENTER MOVIE NAME';
      }
    }
  }

  initForm() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (this.addBtn.disabled) return;

      this.addBtn.disabled = true;
      this.addBtn.innerHTML = 'ADDING...';

      const formData = new FormData(this.form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((r) => {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(() => {
          this.addBtn.innerHTML = 'ADDED!';
          if (typeof openCartDrawer === 'function') openCartDrawer();
          if (typeof updateCartCount === 'function') updateCartCount();
          setTimeout(() => {
            this.addBtn.disabled = false;
            this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
          }, 2000);
        })
        .catch(() => {
          this.addBtn.disabled = false;
          if (this._sizeChosen && this.personalizationInput.value.trim()) {
            this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
          } else {
            this.addBtn.disabled = true;
            this.addBtn.innerHTML = 'FILL ALL FIELDS';
          }
        });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('MoviePosterJson')) {
    new MoviePoster();
  }
});
